export const GET_SMS_SETTINGS_STARTED = "GET_SMS_SETTINGS_STARTED"
export const GET_SMS_SETTINGS_SUCCESS = "GET_SMS_SETTINGS_SUCCESS"
export const GET_SMS_SETTINGS_FAILURE = "GET_SMS_SETTINGS_FAILURE"


export const UPDATE_SMS_SETTINGS_STARTED = "UPDATE_SMS_SETTINGS_STARTED"
export const UPDATE_SMS_SETTINGS_SUCCESS = "UPDATE_SMS_SETTINGS_SUCCESS"
export const UPDATE_SMS_SETTINGS_FAILURE = "UPDATE_SMS_SETTINGS_FAILURE"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"